/**
 * Below this **window** width, calendar chips hide status, series, and checkbox
 * icons so the name stays readable. Type icons stay visible.
 */
export const SCHEDULE_CALENDAR_EVENT_ICON_MIN_WIDTH_PX = 850;
